import type { PropsWithChildren } from "react";

import { graphql, useFragment } from "react-relay";

import { PageWithBreadCrumbs } from "app/components/layout/PageWithBreadCrumbs";
import { useSettingsBreadcrumbs } from "app/hooks/routing/useSettingsBreadcrumbs";

import { type AccessModelSettingsPage_query$key } from "./__generated__/AccessModelSettingsPage_query.graphql";

interface Props extends PropsWithChildren {
  queryRef: AccessModelSettingsPage_query$key;
  /** Whether to wrap the page content in a card-like Paper */
  withPaper?: boolean;
}

export function AccessModelSettingsPage({
  queryRef,
  children,
  withPaper,
}: Props) {
  const data = useFragment(
    graphql`
      fragment AccessModelSettingsPage_query on Query {
        ...PageWithBreadCrumbs_query
      }
    `,
    queryRef,
  );

  const breadcrumbs = useSettingsBreadcrumbs();

  return (
    <PageWithBreadCrumbs
      breadcrumbs={breadcrumbs}
      defaultTitle="Settings"
      queryRef={data}
      title="Access Model"
      withPaper={withPaper}
    >
      {children}
    </PageWithBreadCrumbs>
  );
}
